import React from 'react';
import * as moment from 'moment';
import * as RTO from '@nkr/views/center-admin/action-center/center-performance/relative-performance-overlays';
import { Col, Glyphicon, OverlayTrigger, Row, Table } from 'react-bootstrap';
import { ICompositeScore } from '@nkr/models/composite-score-dashboard/composite-score';

interface IProps {
    centerId: number,
    centerAlias: string,
    isPartnerCenter: boolean,
    data: ICompositeScore
}

const CompositeScore = ({ centerId, centerAlias, isPartnerCenter, data }: IProps) => {
    const startDate = moment().subtract(24, 'month').format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');

    const list = [
        // {
        //     label: <span style={{ fontWeight: 550 }}>Composite Score</span>,
        //     value: <span style={{ fontWeight: 'bold' }}>{centerAlias}</span>,
        //     backgroundColor: '#A6C9EC',
        //     fontWeight: 700
        // },
        {
            label: <>Partner Center</>,
            value: <span style={{ color: isPartnerCenter ? 'green' : 'red' }}>{isPartnerCenter ? <Glyphicon glyph='ok' /> : <Glyphicon glyph='remove' />}</span>
        },
        {
            label: <>Accepts Any Anatomy for Waitlist Chain Ends</>,
            value: <span style={{ color: data.acceptsAnyAnatomy ? 'green' : 'red' }}>{data.acceptsAnyAnatomy ? <Glyphicon glyph='ok' /> : <Glyphicon glyph='remove' />}</span>
        },
        {
            label:
                <div style={{ width: 'fit-content' }}>
                    <OverlayTrigger trigger={['hover', 'hover']} placement='right' overlay={<RTO.ChainEndDeclineRatioOverlay chainEndDeclineRatio={null} />}>
                        <div style={{ cursor: 'pointer' }}>Waitlist Chain End Decline Ratio <Glyphicon glyph='info-sign' style={{ color: '#a1a1a1' }} /></div>
                    </OverlayTrigger>
                </div>,
            value: <>{data.waitlistDeclineRatio}</>
        },
        {
            label:
                <a href={`/center/${centerId}/donors/swap?center=${centerId}&status%5B%5D=donated&type%5B%5D=fv&type%5B%5D=bridge&type%5B%5D=dd&remote=undefined&dob=&donatedStartDate=${startDate}&donatedEndDate=${endDate}&did=0`} target='_blank'>
                    <div style={{ fontWeight: 550 }}>Family Voucher Donations</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(Last 24 Months)</div>
                </a>,
            value: <>{data.familyVoucherDonations}</>
        },
        {
            label:
                <a href={`center/${centerId}/donors/swap?center=${centerId}&status%5B%5D=donated&type%5B%5D=sv&type%5B%5D=bridge&type%5B%5D=dd&remote=1&dob=&donatedStartDate=${startDate}&donatedEndDate=${endDate}&did=0`} target='_blank'>
                    <div style={{ fontWeight: 550 }}>Standard Voucher Donations</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(Last 24 Months)</div>
                </a>,
            value: <>{data.standardVoucherDonations}</>
        },
        {
            label:
                <a href={`/center/${centerId}/reports/my-center/cpr-score-audit-report?startDate=${startDate}&endDate=${endDate}&included=0&compatible=1&transplanted=1`} target='_blank'>
                    <div style={{ fontWeight: 550 }}>Compatible Transplants</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(Paired or Standard Voucher Last 24 Months)</div>
                </a>,
            value: <>{data.compatibleTransplants}</>
        },
        {
            label:
                <a href={`/center/${centerId}/donors/swap?center=${centerId}&status%5B%5D=donated&type%5B%5D=bridge&type%5B%5D=dd&type%5B%5D=remote&remote=1&dob=&donatedStartDate=${startDate}&donatedEndDate=${endDate}&compatible=1&did=0`} target='_blank'>
                    <div style={{ fontWeight: 550 }}>Remote Compatible Donors SV or Paired</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(Last 24 Months)</div>
                </a>,
            value: <>{data.remoteCompatibleDonors}</>
        },
        {
            label:
                <a href={`/center/${centerId}/donors/swap?status%5B%5D=active&status%5B%5D=inactive&status%5B%5D=donated&type%5B%5D=fv&type%5B%5D=bridge&type%5B%5D=dd&remote=1&dob=&donatedStartDate=2008-01-01&donatedEndDate=${endDate}&voucherStatus=2&did=0`} target='_blank'>
                    <div style={{ fontWeight: 550 }}>Redeemed Family Voucher Donations</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(All Time)</div>
                </a>,
            value: <>{data.familyVoucherRedeemedDonations}</>
        },
        {
            label: <a href={`/center/${centerId}/profile/edit/anatomy-prefs`} target='_blank'>Accepts Any Anatomy with Zero Waitlist Chain End Decline Ratio 20% Bonus</a>,
            value: <>{isPartnerCenter ? data.anyAnatomyDeclineRatioBonus.toString() : 'N/A'}</>
        },
        {
            label: <>Composite Score</>,
            value: <span style={{ fontWeight: 550 }}>{isPartnerCenter ? data.compositeScore.toString() : 'N/A'}</span>,
            backgroundColor: '#ccc',
            fontWeight: 700
        },
    ];

    return (
        <div style={{ paddingTop: 10 }}>
            <Row>
                <Col xs={12} lg={5}>
                    <Table condensed bordered>
                        <thead>
                            <tr style={{ height: 42, backgroundColor: '#A6C9EC' }}>
                                <th style={{ verticalAlign: 'middle' }}>Composite Score</th>
                                <th colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle' }}>{centerAlias}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((item, index) =>
                                <tr key={'item-' + index} style={{ height: 46, backgroundColor: item.backgroundColor }}>
                                    <td style={{ fontWeight: item.fontWeight, paddingLeft: 10, verticalAlign: 'middle' }}>
                                        {item.label}
                                    </td>
                                    <td style={{ textAlign: 'center', verticalAlign: 'middle', minWidth: 100 }}>
                                        {item.value}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    );
}

export default CompositeScore;
